import { format, parse, isValid } from "date-fns";

export const parseDateIfItsValidAndMatchesFormat = ({
    dateString,
    formatString,
}: {
    dateString: string;
    formatString: string;
}): Date | false => {
    // @HACK reference date is needed in parse function but wont change the output of checking if the date is valid and same format
    const referenceDate = new Date(1970, 0, 1);
    const parsedDate = parse(dateString, formatString, referenceDate);
    if (!isValid(parsedDate)) return false;
    const isMatchingFormat = format(parsedDate, formatString) === dateString;
    if (!isMatchingFormat) return false;
    return parsedDate;
};
